import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AppContext } from "../context/AppContext";
import Utils from "../utils/Utils";
import { useNavigate } from "react-router-dom";
import * as Fi from "react-icons/fi";
import * as Fa from "react-icons/fa";
import { PulseLoader, HashLoader } from "react-spinners";
import { Switch, Modal } from "antd";
import { toast } from "react-toastify";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import TablePagination, {
  DEFAULT_PAGE_SIZE,
  paginateList,
} from "../components/custom/TablePagination";
import "../styles/style.css";

function ReservationSettings() {
  const navigate = useNavigate();
  const {
    reservationSettings,
    tokenData,
    reservSettingsLoading,
    updateReservationSettings,
    fetchCurrentSettings,
    holidaysList,
    removeHolidaySingle,
    getAllholidays,
    holidaysLoading,
    createNewHoliday,
    getUpcomingHolidaysList,
    upComingHolidays,
    foodpageReservSettings,
    closureList,
    reservFoodpageTiming,
    reservationLoading,
    reservationStatus,
    createNewClosure,
    closuresAllHistory,
    closuresHistory,
    updateSettings,
    getSettings,
  } = useContext(AppContext);
  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const [showModal, setShowModal] = useState(false);
  const [exception, setException] = useState({
    startDate: "",
    endDate: "",
    reason: "",
    status: "Active",
  });
  const [selectedRemoveIndex, setSelectedRemoveIndex] = useState(-1);
  const [warningModal, setWarningModal] = useState(false);
  const [reservStatus, setReservStatus] = useState(false);
  const [closuresTab, setClosuresTab] = useState("active");
  const [closuresPage, setClosuresPage] = useState(1);

  useEffect(() => {
    setClosuresPage(1);
  }, [closuresTab, closureList, closuresHistory]);

  const closuresSource =
    closuresTab === "active" ? closureList : closuresHistory;
  const closuresPaged = useMemo(
    () => paginateList(closuresSource, closuresPage, DEFAULT_PAGE_SIZE),
    [closuresSource, closuresPage]
  );

  // const exceptionData =
  //   reservationSettings &&
  //   reservationSettings?.exceptions &&
  //   reservationSettings?.exceptions.length != 0 &&
  //   typeof reservationSettings?.exceptions == "string"
  //     ? JSON.parse(reservationSettings?.exceptions)
  //     : null;

  useEffect(() => {
    const actualStatus = reservationStatus === "Enabled" ? true : false;
    setReservStatus(actualStatus);
  }, [reservationStatus]);

  const handleExceptions = (e) => {
    const { name, value } = e.target;
    setException((prev) => {
      if (name === "startDate" && value) {
        const startDate = new Date(value);

        const endDate = new Date(startDate);
        endDate.setHours(startDate.getHours() + 12);

        return {
          ...prev,
          startDate: value,
          endDate: endDate.toISOString().slice(0, 16),
        };
      }

      // Otherwise, just update the changed field
      return { ...prev, [name]: value };
    });
  };

  const handleChangeStatus = async () => {
    const alterValue = !reservStatus;

    const statusValue = alterValue === true ? "Enabled" : "Disabled";

    const {
      updated_at,
      source,
      id,
      shopID,
      currencyDetails,
      ...rest
    } = foodpageReservSettings;

    const payload = {
      ...rest,
      reservationStatus: statusValue,
      source: "REACT",
    };

    await updateSettings(payload, {
      onSuccess: async (res) => {
        toast.info(`Reservation ${alterValue ? "Enabled" : "Disabled"}`);
        await getSettings();
        setWarningModal(false);
      },
      onFailed: (err) => {
        console.log("updated error", err);
        throw new Error(err);
      },
    });
  };

  const handleDeleteHoliday = async (id, index) => {
    if (!id) return;

    const token = localStorage.getItem("UserRetention");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      setSelectedRemoveIndex(index);
      await removeHolidaySingle(id, {
        onSuccess: async (res) => {
          toast.success("Holiday is removed");
          console.log("holiday resp", res);
          await closuresAllHistory();
          await getSettings();
        },
        onFailed: (err) => {
          toast.error("Something went wrong!");
          console.log("Error on deleting holiday", err);
        },
        headers: headers,
      });
    } finally {
      setSelectedRemoveIndex(-1);
    }
  };

  const exceptionEmptyValidation = () => {
    if (
      !exception ||
      exception?.endDate.length == 0 ||
      exception.startDate.length === 0 ||
      exception.status.length === 0
    ) {
      toast.error("Please fill required fields!");
      return false;
    }
    return true;
  };

  const handleAddNewHoliday = async (e) => {
    e.preventDefault();

    const isValid = exceptionEmptyValidation();

    if (isValid === false) return;

    const payload = {
      startTime: Utils.formatExceptionDatetime(exception.startDate),
      endTime: Utils.formatExceptionDatetime(exception.endDate),
      reason: exception.reason,
      status: exception.status,
      source: "REACT",
    };

    await createNewClosure(payload, {
      onSuccess: async (res) => {
        toast.success("Created successfully!");
        await getSettings();
        await closuresAllHistory();
        closeModal();
      },
      onFailed: (err) => {
        toast.error("Holiday is not created!");
        console.log("holiday creation error", err);
      },
    });
  };

  const today = new Date().toISOString().slice(0, 16);

  const closeModal = () => {
    setException({ startDate: "", endDate: "", reason: "", status: "Active" });
    setShowModal(false);
  };

  const closeWarningModal = () => {
    setWarningModal(false);
  };

  const statusMidFunction = () => {
    if (reservStatus == true) {
      setWarningModal(true);
      return;
    }

    handleChangeStatus();
  };

  return (
    <Fragment>
      <MasterLayout>
        <Modal
          open={showModal}
          onOk={() => setShowModal(true)}
          onCancel={closeModal}
          footer={null}
        >
          <p className="sub_title_new" style={{ fontSize: "20px" }}>
            Add New Closure
          </p>
          <p className="subtitle_2">
            * Define special opening hours for holidays, events or other needs.
            Leave the time empty if you're closed all day.
          </p>
          <div className="form-group position-relative">
            <form onSubmit={handleAddNewHoliday}>
              <div className="row mt-3">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <label htmlFor="" className="form-label">
                    Start Date
                  </label>
                  <input
                    type="datetime-local"
                    name="startDate"
                    id=""
                    className="form-control"
                    onChange={handleExceptions}
                    value={exception.startDate}
                    min={today}
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <label htmlFor="" className="form-label">
                    End Date
                  </label>
                  <input
                    type="datetime-local"
                    name="endDate"
                    id=""
                    className="form-control"
                    onChange={(e) => handleExceptions(e)}
                    value={exception.endDate}
                    min={today}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    name=""
                    id=""
                    className="form-select"
                    onChange={(e) => {
                      setException((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }));
                    }}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Hold">Hold</option>
                  </select>
                </div>
              </div>

              <div className="form-group mt-3">
                <label htmlFor="" className="form-label">
                  Comments
                </label>
                <textarea
                  name="reason"
                  id=""
                  cols="30"
                  className="form-control"
                  onChange={handleExceptions}
                  value={exception.reason}
                ></textarea>
              </div>
              <br />
              <button
                className="submit_btn"
                type="submit"
                disabled={reservationLoading || reservSettingsLoading}
              >
                {!reservationLoading || !reservSettingsLoading ? (
                  "ADD"
                ) : (
                  <PulseLoader color="#fff" size={10} />
                )}
              </button>
            </form>
          </div>
        </Modal>

        {/* warning modal for disable/enable modal */}
        <Modal
          open={warningModal}
          onClose={closeWarningModal}
          footer={null}
          onCancel={closeWarningModal}
        >
          <h4 className="sub_title_">Disable Table Reservation?</h4>
          <br />
          <p className="mt-4 fs-6">
            Disabling table reservations will make the reservation feature
            unavailable on the client site. Customers will not be able to
            reserve tables until you enable it again.
          </p>
          <hr />
          <br />
          <div className="d-flex">
            <button
              type="button"
              className="admin_btn"
              style={{ padding: "0.5rem 1.5rem" }}
              onClick={handleChangeStatus}
              disabled={reservSettingsLoading}
            >
              {reservSettingsLoading ? "Please wait!" : "Disable Reservation"}
            </button>
            <button
              type="button"
              className="btn btn-light ms-2 rounded-pill px-3"
              style={{ padding: "0.5rem 1.5rem" }}
              onClick={closeWarningModal}
            >
              Cancel
            </button>
          </div>
        </Modal>

        <div className="rs-settings">
          <header className="rs-settings__header">
            <button
              type="button"
              className="rs-settings__back"
              onClick={() => navigate("/table-enquiry-list")}
            >
              <MdKeyboardArrowLeft /> Back
            </button>
            <div className="rs-settings__heading">
              <h1 className="rs-settings__title">
                Table Reservation Settings
              </h1>
              <button
                type="button"
                className="rs-settings__edit"
                onClick={() => navigate("/edit-reservation-settings")}
              >
                <Fi.FiEdit3 /> Edit Settings
              </button>
            </div>
          </header>

          {reservSettingsLoading ? (
            <div className="rs-settings__loader">
              <HashLoader color="#f44336" />
            </div>
          ) : (
            <>
              {/* Reservation Status */}
              <section className="rs-settings-card rs-settings-card--status">
                <span className="rs-settings-card__label">
                  Reservation Status
                </span>
                <div className="rs-settings-status">
                  <Switch
                    onChange={statusMidFunction}
                    checked={reservStatus}
                    size="default"
                  />
                  <span
                    className={
                      reservStatus
                        ? "rs-settings-status__text is-on"
                        : "rs-settings-status__text is-off"
                    }
                  >
                    {reservStatus ? "Enabled Now" : "Disabled Now"}
                  </span>
                </div>
              </section>

              {/* Basic Information */}
              <section className="rs-settings-card">
                <h2 className="rs-settings-card__title">Basic Information</h2>
                <div className="rs-settings-info">
                  <div className="rs-settings-info__item">
                    <span className="rs-settings-info__label">Shop Name</span>
                    <span className="rs-settings-info__value">
                      {tokenData?.shopName ?? "N/A"}
                    </span>
                  </div>
                  <div className="rs-settings-info__item">
                    <span className="rs-settings-info__label">Shop URL</span>
                    <span className="rs-settings-info__value">
                      {tokenData?.shopUrl ?? "N/A"}
                    </span>
                  </div>
                  <div className="rs-settings-info__item">
                    <span className="rs-settings-info__label">Email</span>
                    <span className="rs-settings-info__value">
                      {tokenData?.email ?? "N/A"}
                    </span>
                  </div>
                  <div className="rs-settings-info__item">
                    <span className="rs-settings-info__label">Mobile</span>
                    <span className="rs-settings-info__value">
                      {tokenData?.mobile ?? "N/A"}
                    </span>
                  </div>
                  <div className="rs-settings-info__item">
                    <span className="rs-settings-info__label">
                      Plugin Domain
                    </span>
                    {tokenData?.pluginDomain ? (
                      <a
                        className="rs-settings-info__link"
                        href={tokenData.pluginDomain}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {tokenData.pluginDomain}
                        <Fi.FiExternalLink aria-hidden />
                      </a>
                    ) : (
                      <span className="rs-settings-info__value">N/A</span>
                    )}
                  </div>
                </div>
              </section>

              {/* Closures */}
              <section className="rs-settings-card">
                <h2 className="rs-settings-card__title">
                  Table Reservation Closures
                </h2>
                <div className="rs-settings-closures__bar">
                  <div
                    className="rs-settings-tabs"
                    role="tablist"
                    aria-label="Closures"
                  >
                    <button
                      type="button"
                      role="tab"
                      className={
                        closuresTab === "active"
                          ? "rs-settings-tabs__tab is-active"
                          : "rs-settings-tabs__tab"
                      }
                      aria-selected={closuresTab === "active"}
                      onClick={() => setClosuresTab("active")}
                    >
                      Active ({closureList?.length ?? 0})
                    </button>
                    <button
                      type="button"
                      role="tab"
                      className={
                        closuresTab === "history"
                          ? "rs-settings-tabs__tab is-active"
                          : "rs-settings-tabs__tab"
                      }
                      aria-selected={closuresTab === "history"}
                      onClick={() => setClosuresTab("history")}
                    >
                      History ({closuresHistory?.length ?? 0})
                    </button>
                  </div>
                  <button
                    type="button"
                    className="rs-settings__add"
                    onClick={() => setShowModal(true)}
                    disabled={reservationLoading}
                  >
                    <Fi.FiPlus /> Add New
                  </button>
                </div>

                <div className="rs-settings-table-wrap">
                  <table className="rs-settings-table">
                    <thead>
                      <tr>
                        <th>Reason</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reservationLoading ? (
                        [...Array(3)].map((_, i) => (
                          <tr key={i}>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton circle width={24} height={24} />
                            </td>
                          </tr>
                        ))
                      ) : closuresPaged.total === 0 ? (
                        <tr>
                          <td colSpan={4} className="rs-settings-empty">
                            No closures listed
                          </td>
                        </tr>
                      ) : (
                        closuresPaged.items.map((exc, index) => {
                          const absoluteIndex =
                            (closuresPaged.page - 1) * DEFAULT_PAGE_SIZE +
                            index;
                          const rowKey =
                            closuresTab === "active"
                              ? absoluteIndex
                              : exc?.id;
                          return (
                            <tr key={rowKey}>
                              <td>{exc?.reason || "N/A"}</td>
                              <td>
                                {exc?.startTime
                                  ? Utils.parseAndFormat2(exc.startTime)
                                  : "N/A"}
                              </td>
                              <td>
                                {exc?.endTime
                                  ? Utils.parseAndFormat2(exc.endTime)
                                  : "N/A"}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="rs-settings-trash"
                                  onClick={() =>
                                    handleDeleteHoliday(exc.id, rowKey)
                                  }
                                  disabled={holidaysLoading}
                                  aria-label="Delete closure"
                                >
                                  {selectedRemoveIndex === rowKey &&
                                  holidaysLoading ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <Fa.FaRegTrashAlt />
                                  )}
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                  {!reservationLoading && (
                    <TablePagination
                      page={closuresPaged.page}
                      pageSize={DEFAULT_PAGE_SIZE}
                      total={closuresPaged.total}
                      onPageChange={setClosuresPage}
                    />
                  )}
                </div>
              </section>

              {/* Timings + Additional */}
              {foodpageReservSettings ? (
                <div className="rs-settings__grid">
                  <section className="rs-settings-card">
                    <div className="rs-settings-card__head">
                      <h2 className="rs-settings-card__title">
                        Reservation Timings
                      </h2>
                      <button
                        type="button"
                        className="rs-settings__edit rs-settings__edit--sm"
                        onClick={() =>
                          navigate("/edit-reservation-settings#reserv_timing")
                        }
                      >
                        <Fi.FiEdit3 /> Edit
                      </button>
                    </div>
                    {!reservSettingsLoading ? (
                      reservFoodpageTiming && days?.length > 0 ? (
                        <ul className="rs-settings-timings">
                          {days.map((day) => {
                            const daySlots = reservFoodpageTiming[day] ?? [];
                            const activeSlots = daySlots.filter(
                              (slot) =>
                                slot.status === "active" &&
                                slot.openingTime &&
                                slot.closingTime
                            );
                            return (
                              <li key={day} className="rs-settings-timings__row">
                                <span className="rs-settings-timings__day">
                                  {day}
                                </span>
                                <div className="rs-settings-timings__slots">
                                  {activeSlots.length > 0 ? (
                                    activeSlots.map((slot) => (
                                      <span
                                        key={slot.slotId}
                                        className="rs-settings-pill"
                                      >
                                        {Utils.convertTiming(slot.openingTime)}{" "}
                                        -{" "}
                                        {Utils.convertTiming(slot.closingTime)}
                                      </span>
                                    ))
                                  ) : (
                                    <span className="rs-settings-timings__closed">
                                      Closed
                                    </span>
                                  )}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <p className="rs-settings-empty">No data available</p>
                      )
                    ) : (
                      <Skeleton count={7} />
                    )}
                  </section>

                  <section className="rs-settings-card">
                    <div className="rs-settings-card__head">
                      <h2 className="rs-settings-card__title">
                        Additional settings
                      </h2>
                      <button
                        type="button"
                        className="rs-settings__edit rs-settings__edit--sm"
                        onClick={() =>
                          navigate(
                            "/edit-reservation-settings#additional_settings"
                          )
                        }
                      >
                        <Fi.FiEdit3 /> Edit
                      </button>
                    </div>
                    <ul className="rs-settings-extra">
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Maximum Party Size
                          </div>
                          <div className="rs-settings-extra__hint">
                            Size of the party (Chairs).
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.maxPartySize ?? 0}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Early Booking
                          </div>
                          <div className="rs-settings-extra__hint">
                            Select how early customers can make their booking.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.earlyBooking ===
                            "any_time" ||
                          foodpageReservSettings?.earlyBooking == 0
                            ? "Any Time"
                            : `From ${
                                foodpageReservSettings?.earlyBooking ?? 0
                              } day(s) in advance`}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Late Booking
                          </div>
                          <div className="rs-settings-extra__hint">
                            Select how late customers can make their booking.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {Number(foodpageReservSettings?.lateBooking) > 45
                            ? `From ${Utils.convertMinutesToHours(
                                foodpageReservSettings?.lateBooking ?? 0
                              )} hour(s) in advance`
                            : `From ${
                                foodpageReservSettings?.lateBooking ?? 0
                              } minute(s) in advance`}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Late Cancel
                          </div>
                          <div className="rs-settings-extra__hint">
                            Select how late customers can cancel their booking.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {String(foodpageReservSettings?.lateCancel) === "1"
                            ? "Up to last minute"
                            : Number(foodpageReservSettings?.lateCancel) > 45
                              ? `At least ${Utils.convertMinutesToHours(
                                  foodpageReservSettings?.lateCancel ?? 0
                                )} hour(s) in advance`
                              : `At least ${
                                  foodpageReservSettings?.lateCancel ?? 0
                                } minute(s) in advance`}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Time Interval
                          </div>
                          <div className="rs-settings-extra__hint">
                            Minutes between each available time slot.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {`Every ${
                            foodpageReservSettings?.timeinterval || 0
                          } minutes`}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            View type
                          </div>
                          <div className="rs-settings-extra__hint">
                            How the reservation area is displayed.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.viewType == "formView"
                            ? "Form View"
                            : "Calendar View"}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Auto Approve
                          </div>
                          <div className="rs-settings-extra__hint">
                            Automatically approve reservation requests.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.autoApprove ?? "Disabled"}
                          {foodpageReservSettings?.autoApprove === "Enabled" &&
                          foodpageReservSettings?.autoApproveChairLimit
                            ? ` (≤ ${foodpageReservSettings.autoApproveChairLimit} chairs)`
                            : ""}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Advance Payment
                          </div>
                          <div className="rs-settings-extra__hint">
                            Whether an advance amount is required.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.haveAdvance === "Yes"
                            ? `${
                                foodpageReservSettings?.currencyDetails
                                  ?.currencySymbol ?? ""
                              }${foodpageReservSettings?.advanceAmount ?? "0"} (${
                                foodpageReservSettings?.advanceType === "Chair"
                                  ? "Per Chair"
                                  : foodpageReservSettings?.advanceType ===
                                      "Table"
                                    ? "Per Table"
                                    : "Total"
                              })`
                            : "No"}
                        </div>
                      </li>
                      {foodpageReservSettings?.haveAdvance === "Yes" &&
                        foodpageReservSettings?.advanceType === "Chair" && (
                          <li className="rs-settings-extra__row">
                            <div>
                              <div className="rs-settings-extra__label">
                                Min Chairs for Advance
                              </div>
                              <div className="rs-settings-extra__hint">
                                Advance applies from this party size.
                              </div>
                            </div>
                            <div className="rs-settings-extra__value">
                              {foodpageReservSettings?.minChairs ?? 0}
                            </div>
                          </li>
                        )}
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            OTP Verify
                          </div>
                          <div className="rs-settings-extra__hint">
                            Require OTP verification for bookings.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.otpVerify ?? "Inactive"}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Monthly Report
                          </div>
                          <div className="rs-settings-extra__hint">
                            Automated monthly reservation report email.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.automatedMonthlyReport ===
                          "Yes"
                            ? foodpageReservSettings?.monthlyReportEmail ||
                              "Yes"
                            : "No"}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Guest Reservations
                          </div>
                          <div className="rs-settings-extra__hint">
                            Allow guests without an account to book.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.reservationGuestAllow ??
                            "Disabled"}
                        </div>
                      </li>
                      <li className="rs-settings-extra__row">
                        <div>
                          <div className="rs-settings-extra__label">
                            Guest OTP Verification
                          </div>
                          <div className="rs-settings-extra__hint">
                            Require OTP for guest reservation bookings.
                          </div>
                        </div>
                        <div className="rs-settings-extra__value">
                          {foodpageReservSettings?.reservationGuestOTPVerification ??
                            "Disabled"}
                        </div>
                      </li>
                    </ul>
                  </section>
                </div>
              ) : (
                <section className="rs-settings-card">
                  <p className="rs-settings-empty">Settings not Available!</p>
                </section>
              )}
            </>
          )}
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default ReservationSettings;
